import React from "react";
import './ReportContentContainer.scss'

interface IReportContentContainerProps {
    children: any;
}
export const ReportContentContainer = (props: IReportContentContainerProps) => {
    return (
        <div className="report-content-container">
            {props.children}
        </div>
    )
}